import {Component, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, FormsModule} from '@angular/forms'
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Signup} from '../../model/Signup-model';
import {SignupService} from '../../service/SignupService';
import {Popup} from 'ng2-opd-popup';
import {Router, ActivatedRoute} from '@angular/router';
import * as $ from 'jquery'
import {HttpErrorResponse} from '@angular/common/http';
import {ContactVO} from '../../model/ContactVO'
import {MatSelectModule, MatSelect} from '@angular/material'
import {SealService} from '../../service/SealService'
import {ExporterService} from '../../service/ExporterService';
import {ChaCompanyMasterVO} from '../../model/ChaCompanyMasterVO';
@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],

})
export class SignupComponent implements OnInit {
    checks: boolean
    error: any;
    sign: any = {};
    signupform: FormGroup;
    portlist: any
    portselected: any
    public barLabel: string = "Password strength:";
    userlist: any;

    @ViewChild('popup1') popup1: Popup;
    @ViewChild('popup2') popup2: Popup;
    chaCompanyMasterVO: ChaCompanyMasterVO;
    isnotCHA: boolean = true;
    isCHA: boolean = false;
    signupformCHA: FormGroup;
    states: any
    @ViewChild('popupcha1') popupcha1: Popup;
    @ViewChild('popupcha2') popupcha2: Popup;
    exporter: boolean = false;
    warehouse: boolean = false;
    isnotEW: boolean = true;
    showPort: boolean = true;
    enableReg: boolean = true;
    enableCHAReg: boolean = true;
    IECConfirmation: boolean;
    cFS: boolean = false;
strContainsAphostrophe:boolean = false;
    constructor(private sealservice: SealService, private service: SignupService, private route: ActivatedRoute, private router: Router, private exporterservice: ExporterService) {
        this.signupform = new FormGroup({
            "username": new FormControl(null, [Validators.required, Validators.email]),
            //            "password": new FormControl(null, Validators.required),
            "firstname": new FormControl(null, Validators.required),
            //            "confirmpwd": new FormControl(null, Validators.required),
            "companyname": new FormControl(null, Validators.required),
            //            "companytype": new FormControl(null, Validators.required),
            "ieccode": new FormControl(null, Validators.required),
            "check": new FormControl(null, Validators.required),
            "inmaa1": new FormControl(null),
            "inkat1": new FormControl(null),
            "inkri1": new FormControl(null),
            "tuti": new FormControl(null),
            "coc": new FormControl(null),
            "bang": new FormControl(null),
            "stuffingType": new FormControl(null, Validators.required),
            "portsOfOperation": new FormControl(null)

        });
        this.signupformCHA = new FormGroup({
            "chaLincenseNo": new FormControl(null, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]),
            "chaName": new FormControl(null, Validators.required),
            "address1": new FormControl(null, Validators.required),
            "address2": new FormControl(null),
            "city": new FormControl(null, Validators.required),
            "state": new FormControl(null, Validators.required),
            "postalCode": new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
            "gstNo": new FormControl(null, [Validators.required, Validators.pattern('[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}')]),
            "contactFirstname": new FormControl(null, Validators.required),
            // "contactSecondname": new FormControl(null),
            "email": new FormControl(null, [Validators.required, Validators.email]),
            "mobile": new FormControl(null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
            "check": new FormControl(null, Validators.required)


        });
        this.sign.inmaa = false
        this.sign.inkri = false
        this.sign.inkat = false
        this.sign.inblr5 = false
        this.sign.incok1 = false
        this.sign.intut1 = false
        this.sign.checks = false
        this.sign.contacts = []
        this.chaCompanyMasterVO = new ChaCompanyMasterVO();
    }

    ngOnInit() {
//        this.exporterservice.getAllUsers().subscribe((res) => {
//            res;
//            this.userlist = res;
//            console.log("userlist,", this.userlist)
//        })
        this.loadPorts();
        this.loadState();
    }

    onClick() {
        //        this.sign.portcodes = this.sign.inmaa + ',' + this.sign.inkat + ',' + this.sign.inkri + ',' + this.sign.intut1 + ',' + this.sign.incok1 + ',' + this.sign.inblr5
        //        console.log(this.sign)
        //        let strings = this.sign.portcodes
        //        let x = strings.split(",false");
        //        console.log(x)
        //        let portcodes: string
        //        for (let i = 0; i < x.length; i++) {
        //            if (portcodes == (null || undefined)) {
        //                portcodes = x[i]
        //            }
        //            else {
        //                if (x[i] != "")
        //                    portcodes = portcodes + x[i]
        //            }
        //
        //        }
        //        console.log("ports", portcodes)
        //        console.log("falsecheck", portcodes.search("false") != -1)
        //        if (portcodes.search("false") != -1) {
        //            let st = portcodes
        //            let y = st.split("false,")
        //            console.log("y", y)
        //            let port: string
        //            for (let i = 0; i < y.length; i++) {
        //                if (port == (null || undefined)) {
        //                    port = y[i]
        //                }
        //                else {
        //                    if (y[i] != "")
        //                        port = port + y[i]
        //                }
        //            }
        //            if (port != (null || undefined || "false")) {
        //                this.sign.portcodes = port
        //                console.log("ports1", this.sign.portcodes)
        //            } else {
        //                this.sign.portcodes = undefined
        //            }
        //
        //        } else {
        //            this.sign.portcodes = portcodes
        //            console.log("ports", this.sign.portcodes)
        //        }
        this.enableReg = false;
//        var user = this.userlist.find(user => user.username == this.sign.username)
//        if (user) {
//            window.alert("Email Already Exist,Please Try With Another Email");
//            this.enableReg = true;
//        }
//        else {
            //        else if (this.sign.password == this.sign.confirmpwd) {
            let contact: any = {}
            contact.email = this.sign.username
            contact.firstName = this.sign.firstname
            contact.iskyc = 0
            contact.isActive = 1
            this.sign.contacts.push(contact);
            //this.sign.portcodes = this.sign.inmaa + ',' + this.sign.inkat + ',' + this.sign.inkri + ',' + this.sign.intut1 + ',' + this.sign.incok1 + ',' + this.sign.inblr5
            //            this.service.signupuser(new Signup(this.sign.firstname, this.sign.companyname, this.sign.username, this.sign.password, this.sign.confirmpwd, this.sign.ieccode, this.sign.companytype, this.sign.stuffingType), this.sign.portcodes, this.sign.contacts).subscribe((res) => {
            this.service.signupuser(new Signup(this.sign.firstname, this.sign.companyname, this.sign.username, '', '', this.sign.ieccode, this.sign.companytype, this.sign.stuffingType), this.sign.portcodes, this.sign.contacts).subscribe((res) => {
                res
                if (res) {
                    window.scroll(0, 0);
                    this.popup1.options = {
                        header: "Success",
                        color: "green", // red, blue.... 
                        widthProsentage: 40, // The with of the popou measured by browser width 
                        animationDuration: 1, // in seconds, 0 = no animation 
                        showButtons: false, // You can hide this in case you want to use custom buttons 
                        confirmBtnContent: "OK", // The text on your confirm button 
                        cancleBtnContent: "Cancel", // the text on your cancel button 
                        confirmBtnClass: "btn btn-default", // your class for styling the confirm button 
                        cancleBtnClass: "btn btn-default", // you class for styling the cancel button 
                        animation: "fadeInDown" // 'fadeInLeft', 'fadeInRight', 'fadeInUp', 'bounceIn','bounceInDown' 
                    };
                    this.popup1.show(this.popup1.options);

                }
            },
                (err: HttpErrorResponse) => {
                    this.enableReg = true;
                    //                console.log("Client-side error occured." + err.name);
                    //                console.log("Client-side error occured." + err.message);
                    //                console.log("Client-side error occured." + err.error.message);
                    //                console.log("Client-side error occured." + err.statusText);
                    //                console.log("Client-side error occured." + err.url);
                    if (err.error instanceof Error) {
                        console.log("Client-side error occured." + err.message);
                        window.alert("Login failed...." + err.message);

                    } else {

                        this.error = err.error.message;
                        if (this.error) {
                            this.sign.contacts.pop()
                            window.alert(this.error)
                        }
                        // window.alert("Login failed...." +error);
                    }
                })

//        }
        //        else {
        //            this.popup2.options = {
        //                header: "Error",
        //                color: "red", // red, blue.... 
        //                widthProsentage: 40, // The with of the popou measured by browser width 
        //                animationDuration: 1, // in seconds, 0 = no animation 
        //                showButtons: false, // You can hide this in case you want to use custom buttons 
        //                confirmBtnContent: "Close", // The text on your confirm button 
        //                cancleBtnContent: "Save", // the text on your cancel button 
        //                confirmBtnClass: "btn btn-default", // your class for styling the confirm button 
        //                cancleBtnClass: "btn btn-primary", // you class for styling the cancel button 
        //                animation: "fadeInDown" // 'fadeInLeft', 'fadeInRight', 'fadeInUp', 'bounceIn','bounceInDown' 
        //            };
        //
        //            this.popup2.show(this.popup2.options);
        //
        //
        //        }
    }
    onClickIecCheck() {
        console.log("PO");
        if(this.sign.companyname){
           this.strContainsAphostrophe = this.sign.companyname.includes("'");
        }
        if(this.strContainsAphostrophe == false){
        if(this.sign.stuffingType == 'C'){
            if(this.sign.portcodes){
                if (this.exporter == true) {
            if(this.sign.ieccode.length == 10){
            var r = confirm("Please Ensure IEC Details are Correct.Once Registered IEC Details Cannot be Changed.Are You sure?")
        }else{
           alert("IEC Should Be 10 Characters") 
        } 
        }else if (this.cFS == true) {
            var r = confirm("Please Ensure CFS Code Details are Correct.Once Registered CFS Code Details Cannot be Changed.Are You sure?")
        }
        if (r == true) {
            this.IECConfirmation = true;
            this.onClick();
        } else {
            this.IECConfirmation = false;
        }
            }else{
                alert("Port Of Operation Is Mandatory") ;
            }
        }else{
             if (this.exporter == true) {
            if(this.sign.ieccode.length == 10){
            var r = confirm("Please Ensure IEC Details are Correct.Once Registered IEC Details Cannot be Changed.Are You sure?")
        }else{
           alert("IEC Should Be 10 Characters") 
        } 
        }else if (this.cFS == true) {
            var r = confirm("Please Ensure CFS Code Details are Correct.Once Registered CFS Code Details Cannot be Changed.Are You sure?")
        }
        if (r == true) {
            this.IECConfirmation = true;
            this.onClick();
        } else {
            this.IECConfirmation = false;
        }
        }
        }else{
              alert("Company Name Should Not Contain Apostrophe") 
        }
    }
    onClickCHA() {
        this.enableCHAReg = false;
        console.log("CHA REGISTERATION")
//        var user = this.userlist.find(user => user.username == this.chaCompanyMasterVO.email)
//        if (user) {
//            window.alert("Email Already Exist,Please Try With Another Email");
//            this.enableCHAReg = true;
//        }
//        else {

            this.service.createChaCompanyMaster(this.chaCompanyMasterVO).subscribe((res) => {
                res
                if (res) {
                    window.scroll(0, 0);
                    this.popupcha1.options = {
                        header: "Success",
                        color: "green", // red, blue.... 
                        widthProsentage: 40, // The with of the popou measured by browser width 
                        animationDuration: 1, // in seconds, 0 = no animation 
                        showButtons: false, // You can hide this in case you want to use custom buttons 
                        confirmBtnContent: "OK", // The text on your confirm button 
                        cancleBtnContent: "Cancel", // the text on your cancel button 
                        confirmBtnClass: "btn btn-default", // your class for styling the confirm button 
                        cancleBtnClass: "btn btn-default", // you class for styling the cancel button 
                        animation: "fadeInDown" // 'fadeInLeft', 'fadeInRight', 'fadeInUp', 'bounceIn','bounceInDown' 
                    };
                    this.popupcha1.show(this.popupcha1.options);

                }
            },
                (err: HttpErrorResponse) => {
                    this.enableCHAReg = true;
                    if (err.error instanceof Error) {
                        console.log("Client-side error occured." + err.message);
                        window.alert("Login failed...." + err.message);
                    } else {
                        this.error = err.error.message;
                        if (this.error) {
                            this.sign.contacts.pop()
                            window.alert(this.error)
                        }
                    }
                })

//        }
    }


    popup_close() {
        this.popup1.hide();
        this.router.navigate([''], {skipLocationChange: true});
    }

    popup_close1() {
        this.popup2.hide();

    }
    popupcha_close() {
        this.popupcha1.hide();
        this.router.navigate([''], {skipLocationChange: true});
    }

    popupcha_close1() {
        this.popupcha2.hide();

    }
    sel1(e) {
        if (e.target.checked == true) {
            this.sign.inmaa = e.target.value;
            console.log(this.sign.inmaa);
        }
        else {
            this.sign.inmaa = false;
            console.log(this.sign.inmaa)
        }




    }
    sel2(e1) {
        if (e1.target.checked == true) {
            this.sign.inkat = e1.target.value;
            console.log(this.sign.inkat)
        }
        else {
            this.sign.inkat = false
            console.log(this.sign.inkat)
        }
    }
    sel3(e2) {
        if (e2.target.checked == true) {

            this.sign.inkri = e2.target.value;
            console.log(this.sign.inkri)
        } else {
            this.sign.inkri = false
            console.log(this.sign.inkri)
        }

    }
    sel4(e2) {
        if (e2.target.checked == true) {

            this.sign.intut1 = e2.target.value;
            console.log(this.sign.intut1)
        } else {
            this.sign.intut1 = false
            console.log(this.sign.intut1)
        }

    }
    sel5(e2) {
        if (e2.target.checked == true) {

            this.sign.incok1 = e2.target.value;
            console.log(this.sign.incok1)
        } else {
            this.sign.incok1 = false
            console.log(this.sign.incok1)
        }

    }
    sel6(e2) {
        if (e2.target.checked == true) {

            this.sign.inblr5 = e2.target.value;
            console.log(this.sign.inblr5)
        } else {
            this.sign.inblr5 = false
            console.log(this.sign.inblr5)
        }

    }
    tnc() {
        window.open("http://www.esealstore.com/tnc.html")
    }
    settnc(e) {
        if (e.srcElement.checked == true) {
            this.sign.checks = true
        } else {
            if (e.srcElement.checked == false) {
                this.sign.checks = false
            }
        }
    }
    checkiec(e: any) {
        if (e.length <= 10) {

        }
        else {
            this.sign.ieccode = e.slice(0, 10)
        }
    }
    setports(e) {
        console.log(this.portselected)
        var a: string;
        for (let i = 0; i < this.portselected.length; i++) {
            if (i == 0) {
                a = this.portselected[i]
            } else {
                a = a + ',' + this.portselected[i]
            }
        }
        console.log(a)
        this.sign.portcodes = a
    }

    testclick() {
        //console.log("this.sign.portcodes,",this.sign.portcodes)
        if (this.sign.portcodes != "" && this.sign.portcodes != (null || undefined)) {
            console.log("ports", this.sign.portcodes)
        }
    }
    companyType(e) {
        if (e == 'E') {
            this.isnotCHA = true;
            this.isCHA = false;
            this.exporter = true;
            this.warehouse = false;
            this.isnotEW = false;
            this.cFS = false;
            this.sign.stuffingType = '';
        } else if (e == 'BW') {
            this.isnotCHA = true;
            this.isCHA = false;
            this.exporter = false;
            this.warehouse = true;
            this.isnotEW = false;
            this.cFS = false;
            this.sign.stuffingType = '';
        } else if (e == 'CHA') {
            this.isnotCHA = false;
            this.isCHA = true;
            this.sign.stuffingType = '';
        } else if (e == 'CFS') {
            this.isnotCHA = true;
            this.isCHA = false;
            this.exporter = false;
            this.cFS = true;
            this.warehouse = false;
            this.isnotEW = false;
            this.sign.stuffingType = 'CIX';
            this.sign.portcodes = 'INCCU1'; 

        }
    }
    loadState() {
        this.exporterservice.states().subscribe((res) => {res; this.states = res; console.log(this.states)})
    }
    loadPorts() {
        this.sealservice.getpof().subscribe((res) => {
            res;
            this.portlist = res;
            console.log("portlist,", this.portlist)
        })
    }
    setchatnc(e) {
        if (e.srcElement.checked == true) {
            this.chaCompanyMasterVO.checks = true
        } else {
            if (e.srcElement.checked == false) {
                this.chaCompanyMasterVO.checks = false
            }
        }
    }
    setposmax(e: any) {
        if (e.length <= 6) {

        } else {
            this.chaCompanyMasterVO.postalCode = e.slice(0, 6)
        }
    }
    setmobmax(e: any) {
        if (e.length <= 10) {

        } else {
            this.chaCompanyMasterVO.mobile = e.slice(0, 10)
        }
    }
    setChalisenceNomax(e: any) {
        if (e.length <= 15) {

        } else {
            this.chaCompanyMasterVO.chaLincenseNo = e.slice(0, 15)
        }
    }
    stuffingType(e) {
        if (e == 'C') {
            this.showPort = false;
        } else if (e == 'F') {
            this.showPort = true;
        }
    }
    
    login(){
          this.router.navigate([''], {skipLocationChange: true});
    }
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/signup/signup.component.ts